// src/pages/Videos.jsx
import React, {useEffect, useState} from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { apiFetch } from '../utils/api';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function Videos(){
  const query = useQuery();
  const course_id = query.get('course_id');
  const [videos,setVideos] = useState(null);
  const navigate = useNavigate();

  useEffect(()=>{ if(!course_id) { navigate('/profile'); return; } (async ()=>{ const res = await apiFetch(`getVideos.php?course_id=${course_id}`, { method:'GET' }); if(res.success) setVideos(res.videos); else { alert(res.message || 'No access'); navigate('/profile'); } })() },[course_id]);

  if(!videos) return <div className="container py-4">Loading...</div>;
  return (
    <div className="container py-4">
      <h3>Videos</h3>
      {videos.map(v=>(
        <div key={v.id} className="mb-4">
          <h5>{v.title}</h5>
          <p>{v.description}</p>
          <video controls style={{width:'100%', maxWidth:800}} src={v.video_path}></video>
        </div>
      ))}
    </div>
  );
}
